import { HttpHeaders } from "@angular/common/http";
import { inject, Service } from "@angular/core";

import { Constants } from "../constants/constants";
import { Language } from "../constants/enums";
import { MainResponseModel } from "../models";
import { TranslateRequest, TranslateResponse, ValidatorData } from "../models/translations-model";
import { MainService } from "./main-service";

@Service()
export class TranslationsService {
  private _mainService = inject(MainService);

  public getAssetsAE() {
    const url = `file/translationsDownload/ae`;

    return this._mainService.sendRequest<JSON>({
      method: "GET",
      url,
    });
  }

  public getAssetsEN() {
    const url = `file/translationsDownload/en`;

    return this._mainService.sendRequest<JSON>({
      method: "GET",
      url,
    });
  }

  public getValidatorData(type = Constants.CONSTANT_VALIDATOR_CONF_LIST) {
    const url = `validator/getall?type=${type}`;

    return this._mainService.sendRequest<MainResponseModel<ValidatorData[]>>({
      method: "GET",
      url,
    });
  }

  public save(data: FormData, language: Language) {
    const url = `file/translationsUpload?lang=${language}`;
    const headers = new HttpHeaders();

    headers.append("Content-Type", "application/json");

    return this._mainService.sendRequest<MainResponseModel<number>>({
      method: "POST",
      url,
      data,
      headers,
    });
  }

  public getTranslation(data: TranslateRequest) {
    const url = `translations/translate`;
    const headers = new HttpHeaders();
    return this._mainService.sendRequest<MainResponseModel<TranslateResponse>>({
      method: "POST",
      url,
      data,
      headers,
    });
  }
}
